import DefaultThumbnail from '@public/images/default-thumbnail.png'
import { useAuth } from '@libs/Auth/useAuth'
import { Event } from '@graphql/__generated/graphql'
import Box from '../base/Box'
import MediaCard from '@components/landing/Media'
import { useState } from 'react'
import { Button } from '@components/inputs/Button'
import { isEventAfter } from '@libs/Utility/util'

const EventsView = ({
  events,
  types,
  title,
  currency,
  justify,
  skipSort = false,
}: {
  events: Event[]
  types: string[]
  title: string
  currency: string
  justify?: string
  skipSort?: boolean
}) => {
  const { profile, isOrganizer, isAdmin, canEditEvent } = useAuth()
  const userId = profile?.userId
  const [viewAll, setViewAll] = useState<boolean>(false)

  const isSpeaker = (event: Event): boolean => {
    if (!event || !profile) return false
    return !!event.speakers?.find((f) => f.email === profile?.email)
  }

  const getAttendeeCount = (event: Partial<Event>) => {
    if (!event || (!event.eventId && !event.attendees)) return 0
    if (event?.eventId === '31fffe01-557f-4c3c-a7f3-cb1ec9772277') return 374
    if (event?.eventId === 'e9b5be85-1f71-409b-8b4b-67d3700853f6') return 253
    return event?.attendees?.length
  }

  // TODO: Define types correctly
  const renderEventCard = (e: any) => {
    if (!e) return <></>
    return (
      <MediaCard
        key={e.eventId}
        eventId={e.eventId}
        url={
          e?.event?.eventType === 'FUNDRAISER'
            ? `/donation/${e.event.donationUrl}`
            : `/event/${e.eventId}`
        }
        type={e.event.eventType}
        title={e.event?.title}
        description={e.event?.shortDescription}
        image={e.event?.bannerImage ?? DefaultThumbnail}
        banner={e.event?.thumbnailImage ?? DefaultThumbnail}
        organization={e?.event?.organizationName}
        startTime={e.event?.startDateTime}
        endTime={e.event?.endDateTime}
        timeZone={e.event?.timeZone}
        timeZoneId={e.event?.timeZoneId}
        canEdit={canEditEvent(e)}
        isSpeaker={isSpeaker(e)}
        isPublished={e.isPublished}
        attendees={getAttendeeCount(e)}
        donors={e.fundraising?.donors}
        goal={e.fundraising?.goal}
        raised={e.fundraising?.raised}
        currency={currency ?? 'GBP'}
      />
    )
  }

  // TODO: Define types correctly
  const renderEvents = (data: Event[]) => {
    // TODO: Define types correctly
    return data
      .sort((a, b) => (skipSort ? 0 : isEventAfter(a, b)))
      .map((e: any) => {
        if (e.event?.eventType == null) {
          return null
        }
        if (!types.includes(e.event?.eventType)) {
          return null
        }
        if (
          title.length > 0 &&
          !e.event.title.toLowerCase().includes(title.toLowerCase())
        ) {
          return null
        }
        return renderEventCard(e)
      })
  }

  const justifyClass =
    justify === 'center' ? '' : ' sm:justify-start sm:items-start'

  return (
    <Box
      className={`flex sm:-mx-4 md:w-[110%] max-w-[1530px] flex-wrap justify-center items-center ${justifyClass}`}
    >
      {viewAll ? renderEvents(events) : renderEvents(events?.slice(0, 8))}
      {events.length <= 8 ? (
        <></>
      ) : (
        !viewAll && (
          <Box className="w-full justify-center flex mt-3">
            <Button
              className="sm:min-w-[15rem] text-xs sm:text-sm"
              title="View All"
              type="primary"
              textColor="white"
              onClick={() => setViewAll(true)}
            />
          </Box>
        )
      )}
    </Box>
  )
}

export default EventsView
